module.exports = __webpack_public_path__ + "static/media/d54ru.89185361.pdf";